/* eslint-disable no-param-reassign */
import { Store } from '@wonderlandlabs/looking-glass-engine';
import _ from 'lodash';
import uuid from 'uuid/v4';
import React from 'react';
import { categoryFetchAll, categoryFetchQuery, categoryFetchRecord } from '../../store/models/Category';
import SchemaSet from '../../store/models/SchemaSet';
import {
  eventToNumber, eventToBoolean, eventToString, eventToObject,
}
  from '../../utils/eventExtraction';

export default () => {
  const queryStore = new Store({
    state: {},
    actions: {
      onCloseDrawer({ actions }) {
        actions.setEditVisible(false);
      },
      toggleCollapse({ actions }, event) {
        console.log('toggleCollapse: ', event);
        actions.setCollapse(!eventToBoolean(event));
      },
      async loadSchema({ state, actions }) {
        const { token } = state;
        actions.setSchemaLoadError(false);
        actions.setFetchingSchema(true);
        try {
          const { rows } = await categoryFetchQuery('DESCRIBE media', token);
          const ss = SchemaSet.parse(rows);
          actions.setSchemaLoaded(true);
          actions.setSchema(ss);
        } catch (err) {
          actions.setSchemaLoaded(false);
          actions.setSchemaLoadError(err);
        }
        actions.setFetchingSchema(false);
      },
      loadMedia(store, mediaId) {
        const media = store.state.queryModel;
        const currentMediaItem = mediaId ? _.find(media, { mediaId }) : false;
        store.actions.setCurrentMediaItem(currentMediaItem);
        store.actions.setMediaId(mediaId);
        store.actions.setEditVisbile(!!mediaId);
      },
      updateQueryName(store, name, data) {
        console.log('---qs updateQueryName: ', data, name);
        const key = _.get(data, 'key');
        if (!key) {
          return;
        }

        const { queryTabs } = store.state;
        let tab;
        if (queryTabs) {
          tab = _.find(queryTabs, { key });

          if (tab) {
            tab.name = name;
          }
        }
        store.actions.setQueryTabs([...queryTabs]);
        console.log('updateQueryName: ', name, queryTabs, tab);
      },
      async loadCategories(store, withToken) {
        const { actions } = store;

        if (withToken) {
          actions.setToken(withToken);
        }
        const { token } = store.state;

        if (!token) {
          actions.setCatLoadError(new Error('attempt to get categories without token'));
          return;
        }
        actions.setCatLoading(true);
        actions.setCatLoaded(false);
        actions.setCatLoadError(false);
        try {
          const categories = await categoryFetchAll(token);
          actions.setCategories(categories);
          actions.setCatLoading(false);
          actions.setCatLoaded(true);
        } catch (err) {
          actions.setCategories([]);
          actions.setCatLoading(false);
          actions.setCatLoadError(err);
        }
      },
      onQueryTabChange({ state, actions }, event) {
        if (state.removingTab) return;
        actions.setEditVisible(false);
        actions.setQueryTabKey(eventToString(event));
      },
      removeQuerySub({ actions, state }, data) {
        console.log('in removeQuerySub');
        const key = _.get(data, 'key');
        const otherQueries = _(state.queryTabs)
          .reject({ key })
          .value();

        if (otherQueries.length === 0) {
          actions.setQueryTabs([]);
          actions.addTab();
        } else if (key) {
          const newKey = _.get(otherQueries, '[0].key');
          const out = { ...state };
          out.queryTabs = otherQueries;
          out.queryTabKey = newKey;
          return out;
        }
      },
      async removeQuery({ actions, state }, data) {
        actions.setRemovingTab(true);
        await actions.removeQuerySub(data);
        actions.setRemovingTab(false);
      },
      addTab({ state, actions }, data = {}) {
        const { tabNumber } = state;
        actions.setTabNumber(tabNumber + 1);
        const name = _.get(data, 'name', `New Query ${tabNumber}`);
        const query = _.get(data, 'query', 'select *, hits() from media');
        const category = _.get(data, 'category');

        const key = uuid();

        const queryTabs = [...state.queryTabs];
        queryTabs.push({
          name,
          query,
          category,
          key,
        });
        actions.setQueryTabs(queryTabs);
        actions.setQueryTabKey(key);
      },
      showMedia(store, mediaId, mediaURL) {
        console.log('showMedia: ', mediaId, mediaURL);
        return {
          ...store.state,
          mediaId,
          mediaURL,
          editVisible: true,
        };
      },
      loadCategory({ state, actions }, category) {
        const { categoryName, query } = category;
        actions.addTab({
          name: categoryName,
          category: categoryName,
          query,
        });
      },

      onOpenCat({ state }) {
        return {
          ...state,
          loadingCat: true,
          editVisible: false,
        };
      },
      activateObjDialog({ actions }, title, value, text = '') {
        console.log('activating value-', value, 'title-', title);
        actions.setObjDialogTitle(title);
        actions.setObjDialogValue(value);
        actions.setObjDialogText(text);
        actions.setShowObjDialog(true);
      },
      onCloseCat({ actions }) {
        actions.setLoadingCat(false);
      },
      async onChooseFilter({
        state,
        actions,
      }, event) {
        actions.onCloseCat();
        const name = eventToString(event);
        console.log('onChooseFilter: ', event, 'name:', name);
        try {
          const filter = await categoryFetchRecord(name, state.token);
          actions.loadCategory(filter);
        } catch (err) {
          console.log('onChooseFilter: cannot load ', err);
        }
      }
      ,
    },
  });
  queryStore
    .addProp('objDialogValue', '', 'string')
    .addProp('showObjDialog', false, 'boolean')
    .addProp('objDialogTitle', '', 'string')
    .addProp('objDialogText', '', 'string')
    .addProp('queryTabs', {
      start: [{
        key: 'first',
        name: 'New Query',
        query: 'select *, hits() from media',
      }],
    })
    .addProp('mediaId', {
      start: '',
    })
    .addProp('tabNumber', {
      type: 'integer',
      start: 1,
    })
    .addProp('mediaURL', {
      start: '',
    })
    .addProp('schemaLoadError', {
      start: false,
    })
    .addProp('fetchingSchema', {
      start: false,
      type: 'boolean',
    })
    .addProp('loadingCat', {
      start: false,
      type: 'boolean',
    })
    .addProp('schemaLoaded', {
      start: false,
      type: 'boolean',
    })
    .addProp('schema', {
      start: false,
    })
    .addProp('currentMediaItem', {
      start: false,
    })
    .addProp('editVisible', {
      type: 'boolean',
      start: false,
    })

    .addProp('token', {
      start: '',
      type: 'string',
    })

    .addProp('queryTabKey', {
      start: 'first',
      type: 'string',
    })

    .addProp('categories', {
      start: [],
      type: 'array',
    })
    .addProp('collapse', {
      type: 'boolean',
      start: false,
    })
    .addProp('catLoaded', {
      type: 'boolean',
      start: false,
    })
    .addProp('catLoading', {
      type: 'boolean',
      start: false,
    })
    .addProp('removingTab', {
      type: 'boolean',
      start: false,
    })
    .addProp('catLoadError', {
      start: false,
    });

  queryStore.debugStream = {
    next(data) {
      return;
      console.log(
        '--debug queryStore: change: ',
        _.get(data, 'change.info.action'),
        'resolved', _.get(data, 'change._resolved'),
        'id', _.get(data, 'change.id'),
      );
    },
  };
  queryStore.start();
  return queryStore;
};
